import React from 'react';
import { FetchAssetOptions } from '../../../queries/ats/titles/api';
import { Asset } from '../../../queries/ats/titles/types/asset';
import { Source } from '../../../queries/ats/titles/types/sources';
import { FocusedAsset } from '../use-focused-asset';
import { DetailsParams } from '../utils';
import { DefaultDetailsDataProvider } from './default-details-data-provider';
import { RecordingDetailsDataProvider } from './recording-details-data-provider';

interface DetailsDataArguments {
  asset: Asset;
  focusedAsset: FocusedAsset;
  source: Source;
}

export interface DetailsDataProviderProps extends FetchAssetOptions {
  id: string;
  type: DetailsParams['type'];
  skeleton: JSX.Element | null;
  fallback: JSX.Element | null;
  children: (args: DetailsDataArguments) => JSX.Element;
}

export function DetailsDataProvider({ type, ...rest }: DetailsDataProviderProps) {
  switch (type) {
    case 'recording':
      return <RecordingDetailsDataProvider {...rest} />;
    default:
      return <DefaultDetailsDataProvider {...rest} />;
  }
}
